import Vue from 'vue'
import Vuex from 'vuex'

import { fakeAccounts } from '../fakeData'

Vue.use(Vuex)


const storagePlugin = store => {
    let saved_data = JSON.parse(window.sessionStorage.dpsvuex || '{}')
    let new_state = {}

    Object.assign(new_state, store.state, saved_data)
    store.replaceState(new_state)

    store.subscribe((mutation, state) => {
        try {
            window.sessionStorage.dpsvuex = JSON.stringify(state)
        } catch (e) {
            // i hate you safari
        }
    })
}

const PAGENAME = 'PAGENAME';
const BANKINFO = 'BANKINFO';
const GOALINFO = 'GOALINFO';
const USER = 'USER';
const ACCOUNTS = 'ACCOUNTS';
const SAVINGS_AMT = 'SAVINGS_AMT';
const CHECKING_AMT = 'CHECKING_AMT';
const RESET = 'RESET';
const TRANSFER = 'TRANSFER';
const STATE = 'STATE';
const LOG = 'LOG'

export default new Vuex.Store({
    plugins: [storagePlugin],
    state: {
        pageName: '',
        bankInfo: null,
        goalInfo: null,
        accounts: {
            savings: null,
            checking: null,
        },
        user: null,
        transfer: {
            amount: 0,
            frequency: '',
            dayOfWeek: '',
            dayOfMonth: '',
            skipBelow: false,
            skipAmount: '',
            textNotify: false,
            emailNotify: false,
        },
        state: null,
        transferLog: [],
    },
    getters: {
        activeSavingsAccount: state => state.bankInfo.accounts.find(acct => acct.accountId == state.accounts.savings),
        activeCheckingAccount: state => state.bankInfo.accounts.find(acct => acct.accountId == state.accounts.checking),
    },
    mutations: {
        [PAGENAME] (state, data) {
            state.pageName = data
        },
        [BANKINFO] (state, data) {
            state.bankInfo = data
        },
        [GOALINFO] (state, data) {
            state.goalInfo = data
        },
        [USER] (state, data) {
            state.user = data
        },
        [ACCOUNTS] (state, data) {
            state.accounts = data
        },
        [SAVINGS_AMT] (state, amount) {
            let sav = state.bankInfo.accounts.find(acct => acct.accountId == state.accounts.savings)
            sav.balances[0].amount = amount
        },
        [CHECKING_AMT] (state, amount) {
            let chk = state.bankInfo.accounts.find(acct => acct.accountId == state.accounts.checking)
            chk.balances[0].amount = amount
        },
        [RESET] (state) {
            state.user = null
            state.bankInfo = null
            state.goalInfo = null
            state.accounts = {
                savings: null,
                checking: null,
            }
            state.transfer = {
                amount: 0,
                frequency: '',
                dayOfWeek: '',
                dayOfMonth: '',
                skipBelow: false,
                skipAmount: '',
                textNotify: false,
                emailNotify: false,
            }
            state.state = null
            state.transferLog = []
        },
        [TRANSFER] (state, data) {
            state.transfer = data
        },
        [STATE] (state, data) {
            state.state = data
        },
        [LOG] (state, data) {
            state.transferLog.unshift(data)
        }
    },
    actions: {
        setPageName({commit}, data) {
            commit(PAGENAME, data)
        },
        setUser({commit}, data) {
            commit(USER, data)
        },
        setBankInfo({commit}, data) {
            commit(BANKINFO, data)
        },
        setGoalInfo({commit}, data) {
            commit(GOALINFO, data)
        },
        fakeBankDetails({commit}) {
            let accts = fakeAccounts(3)
            commit(BANKINFO, {
                accounts: accts
            })
        },
        setAccounts({commit}, data) {
            commit(ACCOUNTS, data)
        },
        setSavingsAmount({commit}, amount) {
            commit(SAVINGS_AMT, amount)
        },
        setCheckingAmount({commit}, amount) {
            commit(CHECKING_AMT, amount)
        },
        fullReset({commit}) {
            commit(RESET)
        },
        setTransfer({commit}, data) {
            commit(TRANSFER, data)
        },
        setState({commit}, data) {
            commit(STATE, data)
        },
        logTransfer({commit}, data) {
            commit(LOG, data)
        }
    },
})
